export const yachtTranslations = {
  en: {
    2: {
      name: "Side VIP",
      price: "Starting from 100 €",
      priceUnit: "per day",
      location: "Side Harbor, Turkey",
      builder: "Custom Built",
      description: {
        main: "Experience luxury yachting in Side with our VIP vessel",
        highlights: [
          "Premium service in the beautiful waters of Side",
          "Professional crew at your service",
          "Daily tours from 09:30 to 15:00"
        ],
        location: {
          departure: "Side-Manavgat Marina",
          route: "Scenic Side bays"
        },
        includedMenu: {
          mainDishes: [
            "Fresh Fish",
            "Grilled Chicken",
            "Pasta",
            "Local Specialties"
          ],
          sides: [
            "Mediterranean Salad",
            "Turkish Mezze"
          ],
          beverages: [
            "Soft Drinks",
            "Water",
            "Tea",
            "Coffee"
          ]
        },
        extraServices: {
          note: "Customizable experience with additional services available on request",
          options: [
            "Extended routes available",
            "Special menu modifications possible",
            "Premium beverage packages available"
          ]
        },
        additionalInfo: "Tailored experiences for special occasions and events"
      },
      details: {
        startTime: "10:00 - 15:00",
        totalCapacity: "12 Person",
        totalBreaks: "3 Times",
        totalCabins: "1 Cabins",
        catering: "Included",
        alcoholDrink: "Yes Possible",
        special: "BBQ Party",
        length: "12.5 meters",
        beam: "4.3 meters",
        draft: "1.8 meters",
        enginePower: "2 x 350 HP",
        fuelType: "Diesel",
        maxSpeed: "20 knots",
        cruisingSpeed: "16 knots",
        fuelConsumption: "50L/h",
        guestCapacity: {
          day: "12 persons",
          overnight: "4 persons"
        },
        cabins: {
          total: "1 cabins",
          master: "1 master cabin",
          double: "1 double cabin",
          twin: "0 twin cabins"
        },
        bathrooms: "2 bathrooms",
        navigation: [
          "GPS",
          "Radar",
          "VHF Radio",
          "Autopilot",
          "Depth sounder"
        ],
        entertainment: [
          "TV",
          "Sound system",
          "WiFi",
          "Bluetooth connection"
        ],
        comfort: [
          "Air conditioning",
          "Heating",
          "Generator",
          "Hot water"
        ],
        waterToys: [
          "Snorkeling equipment",
          "Fishing equipment",
          "Water skis"
        ],
        includedServices: [
          "Professional captain",
          "Crew",
          "Fuel",
          "Water",
          "Soft drinks",
          "Snacks",
          "Towels",
          "Insurance"
        ],
        optionalServices: [
          
          {
            name: "Hotel transfer",
            price: "?€ per way"
          },
          
        ],
        cancellation: {
          fullRefund: "7 days before",
          partialRefund: "3-7 days (50%)",
          noRefund: "less than 3 days"
        },
        availability: {
          checkIn: "10:00",
          checkOut: "15:00",
          minDuration: "1 day",
          seasonality: {
            highSeason: "June-September",
            lowSeason: "October-May"
          }
        }
      },
      features: {
        yachtName: "Side VIP",
        yachtType: "Motor Yacht",
        brand: "Custom built",
        capacity: "12 person",
        crew: "2 person",
        cabin: "1",
        showerWC: "1",
        length: "12 meter",
        width: "4 meter",
        speed: "16 Knots",
        manufacturing: "2008",
        refitDate: "2023",
        location: "Side Marina",
        distance: "15 km"
      },
      equipment: {
        comfort: [
          "Wi-Fi",
          "Binoculars",
          "Outside speakers",
          "GPS",
          "Fridge",
          "Standup paddleboard",
          "Indoor speakers",
          "Towel",
          "Life vest"
        ],
        activities: [
          "Swim ladder",
          "Grill",
          "Modern dinnerware set",
          "Bluetooth connection",
          "Amateur fishing gear",
          "Snorkel and Fins",
          "Sun Pads"
        ]
      },
      services: {
        included: {
          foodAndBeverage: {
            title: "Food and beverage",
            description: "Complimentary menu and non-alcoholic beverages included."
          },
          
          fuel: {
            title: "Fuel",
            description: "All fuel costs included in charter price."
          },
          waiterAndCrew: {
            title: "Waiter and crew",
            description: "Professional crew service included.Please inform us in advance about any special conditions (e.g., gluten allergy, etc.). No additional charge."
          },
          fixedMenu: {
            title: "Fixed menu content",
            items: [
              "Fresh Fish",
              "Grilled Chicken",
              "Local Pasta",
              "Mediterranean Salad",
              "Seasonal Fruit",
              "Soft Drinks",
              "Grilled vegetables"
              
              
            ]
          }
        },
        extras: {
          birthdayCake: {
            title: "Birthday cake",
            description: "Custom birthday cakes available on request."
          },
          bringingAlcohol: {
            title: "Bringing alcohol",
            description: "35€ service charge for bringing own alcohol."
          },
          purchasingAlcohol: {
            title: "Purchasing Alcohol",
            description: "Available for purchase onboard."
          },
          modifyingMenu: {
            title: "Menu Modifications",
            description: "Custom menu options available at additional cost."
          },
         
          waterActivities: {
            title: "Water Activities",
            description: "Additional water sports available for fee. Jet ski, parasailing are available."
          },
          photographyServices: {
            title: "Photography and Drone Shot",
            description: "Professional photo and drone services available."
          },
          transfer: {
            title: "Transfer",
            description: "Custom transfer services based on group size."
          },
          decoration: {
            title: "Decoration",
            description: "Custom decorations available for special occasions."
          }
        }
      },
      images: [
        '/images/20240523_132216.jpg',
        '/images/20240528_122608.jpg',
        '/images/20240609_194627.jpg',
        '/images/DJI_0720+ kopya.jpg',
        '/images/IMG_20220603_140435_581.jpg',
        '/images/IMG_20220711_225349_830.jpg',
        '/images/IMG-20230525-WA0014.jpg',
        '/images/IMG-20230501-WA0005.jpg'
      ],
      image: "/images/20240520_111108.jpg",
      year: 2008,
      length: "12.5m"
    }
  },
  tr: {
    2: {
      name: "Side VIP",
      price: "100 €'dan başlayan fiyatlarla",
      priceUnit: "günlük",
      location: "Side Limanı, Türkiye",
      builder: "Özel Yapım",
      description: {
        main: "Side'de VIP teknemizle lüks yatçılık deneyimi yaşayın",
        highlights: [
          "Side'nin güzel sularında premium hizmet",
          "Profesyonel ekip hizmetinizde",
          "09:30 - 15:00 arası günlük turlar"
        ],
        location: {
          departure: "Side-Manavgat Marina",
          route: "Muhteşem Side koyları"
        },
        includedMenu: {
          mainDishes: [
            "Taze Balık",
            "Izgara Tavuk",
            "Makarna",
            "Yerel Lezzetler"
          ],
          sides: [
            "Akdeniz Salatası",
            "Türk Mezesi"
          ],
          beverages: [
            "Alkolsüz İçecekler",
            "Su",
            "Çay",
            "Kahve"
          ]
        },
        extraServices: {
          note: "İsteğe bağlı ek hizmetlerle özelleştirilebilir deneyim",
          options: [
            "Uzatılmış rotalar mevcut",
            "Özel menü değişiklikleri mümkün",
            "Premium içecek paketleri mevcut"
          ]
        },
        additionalInfo: "Özel günler ve etkinlikler için özelleştirilmiş deneyimler"
      },
      details: {
        startTime: "10:00 - 15:00",
        totalCapacity: "12 Kişi",
        totalBreaks: "3 Mola",
        totalCabins: "2 Kabin",
        catering: "Dahil",
        alcoholDrink: "Mümkün",
        special: "BBQ Partisi",
        length: "12.5 metre",
        beam: "4.3 metre",
        draft: "1.8 metre",
        enginePower: "2 x 350 HP",
        fuelType: "Dizel",
        maxSpeed: "16 knot",
        cruisingSpeed: "16 knot",
        fuelConsumption: "50L/s",
        guestCapacity: {
          day: "12 kişi",
          overnight: "4 kişi"
        },
        cabins: {
          total: "1 kabin",
          master: "1 master kabin",
          double: "1 çift kişilik kabin",
          twin: "0 twin kabin"
        },
        bathrooms: "2 banyo",
        navigation: [
          "GPS",
          "Radar",
          "VHF Telsiz",
          "Otopilot",
          "Derinlik ölçer"
        ],
        entertainment: [
          "TV",
          "Ses sistemi",
          "WiFi",
          "Bluetooth bağlantısı"
        ],
        comfort: [
          "Klima",
          "Isıtma",
          "Jeneratör",
          "Sıcak su"
        ],
        waterToys: [
          "Şnorkel ekipmanı",
          "Balık tutma ekipmanı",
          "Su kayağı"
        ],
        includedServices: [
          "Profesyonel kaptan",
          "Mürettebat",
          "Yakıt",
          "Su",
          "Alkolsüz içecekler",
          "Atıştırmalıklar",
          "Havlular",
          "Sigorta"
        ],
        optionalServices: [
          
          {
            name: "Otel transferi",
            price: "Tek yön ?€"
          },
          
        ],
        cancellation: {
          fullRefund: "7 gün öncesinde",
          partialRefund: "3-7 gün (%50)",
          noRefund: "3 günden az"
        },
        availability: {
          checkIn: "10:00",
          checkOut: "15:00",
          minDuration: "1 gün",
          seasonality: {
            highSeason: "Haziran-Eylül",
            lowSeason: "Ekim-Mayıs"
          }
        }
      },
      features: {
        yachtName: "Side VIP",
        yachtType: "Motor Yat",
        brand: "Özel yapım",
        capacity: "12 kişi",
        crew: "2 kişi",
        cabin: "1",
        showerWC: "1",
        length: "12 metre",
        width: "4 metre",
        speed: "16 Knot",
        manufacturing: "2008",
        refitDate: "2023",
        location: "Side Marina",
        distance: "15 km"
      },
      equipment: {
        comfort: [
          "Wi-Fi",
          "Dürbün",
          "Dış mekan hoparlörleri",
          "GPS",
          "Buzdolabı",
          "Surf tahtası",
          "İç mekan hoparlörleri",
          "Havlu",
          "Can yeleği"
        ],
        activities: [
          "Yüzme merdiveni",
          "Izgara",
          "Modern yemek takımı",
          "Bluetooth bağlantısı",
          "Amatör balıkçılık ekipmanı",
          "Şnorkel ve Palet",
          "Güneşlenme minderleri"
        ]
      },
      services: {
        included: {
          foodAndBeverage: {
            title: "Yiyecek ve içecek",
            description: "Ücretsiz menü ve alkolsüz içecekler dahildir."
          },
          
          fuel: {
            title: "Yakıt",
            description: "Tüm yakıt masrafları kiralama ücretine dahildir."
          },
          waiterAndCrew: {
            title: "Garson ve mürettebat",
            description: "Profesyonel mürettebat hizmeti dahildir. Lütfen özel durumlarınızı (örneğin, gluten alerjisi vb.) önceden bildirin. Ek ücret talep edilmez."
          },
          fixedMenu: {
            title: "Sabit menü içeriği",
            items: [
              "Taze Balık",
              "Izgara Tavuk",
              "Yerel Makarna",
              "Akdeniz Salatası",
              "Mevsim Meyveleri",
              "Alkolsüz İçecekler",
              "Izgara sebzeler"
             
            ]
          }
        },
        extras: {
          birthdayCake: {
            title: "Doğum günü pastası",
            description: "İsteğe özel doğum günü pastaları mevcuttur."
          },
          bringingAlcohol: {
            title: "Alkol getirme",
            description: "Kendi alkolünüzü getirmek için 35€ servis ücreti."
          },
          purchasingAlcohol: {
            title: "Alkol satın alma",
            description: "Teknede satın alma imkanı mevcuttur."
          },
          modifyingMenu: {
            title: "Menü Değişiklikleri",
            description: "Ek ücretle özel menü seçenekleri mevcuttur."
          },
         
          waterActivities: {
            title: "Su Aktiviteleri",
            description: "Ek ücretle su sporları aktiviteleri mevcuttur. Jet ski, parasailing mevcuttur."
          },
          photographyServices: {
            title: "Fotoğrafçılık ve Drone Çekimi",
            description: "Profesyonel fotoğraf ve drone hizmetleri mevcuttur."
          },
          transfer: {
            title: "Transfer",
            description: "Grup büyüklüğüne göre özel transfer hizmetleri."
          },
          decoration: {
            title: "Dekorasyon",
            description: "Özel günler için özel dekorasyonlar mevcuttur."
          },
        }
      },
      images: [
        '/images/20240523_132216.jpg',
        '/images/20240528_122608.jpg',
        '/images/20240609_194627.jpg',
        '/images/DJI_0720+ kopya.jpg',
        '/images/IMG_20220603_140435_581.jpg',
        '/images/IMG_20220711_225349_830.jpg',
        '/images/IMG-20230525-WA0014.jpg',
        '/images/IMG-20230501-WA0005.jpg'
      ],
      image: "/images/20240520_111108.jpg",
      year: 2008,
      length: "12.5m"
    }
  },
  de: {
    2: {
      name: "Side VIP",
      price: "Ab 100 €",
      priceUnit: "pro Tag",
      location: "Side Hafen, Türkei",
      builder: "Individualbau",
      description: {
        main: "Erleben Sie Luxus-Yachting in Side mit unserem VIP-Schiff",
        highlights: [
          "Premium-Service in den schönen Gewässern von Side",
          "Professionelle Crew zu Ihren Diensten",
          "Tägliche Touren von 09:30 bis 15:00"
        ],
        location: {
          departure: "Side-Manavgat Marina",
          route: "Malerische Buchten von Side"
        },
        includedMenu: {
          mainDishes: [
            "Frischer Fisch",
            "Gegrilltes Hähnchen",
            "Pasta",
            "Lokale Spezialitäten"
          ],
          sides: [
            "Mediterraner Salat",
            "Türkische Mezze"
          ],
          beverages: [
            "Alkoholfreie Getränke",
            "Wasser",
            "Tee",
            "Kaffee"
          ]
        },
        extraServices: {
          note: "Individuell anpassbares Erlebnis mit zusätzlichen Services auf Anfrage",
          options: [
            "Erweiterte Routen verfügbar",
            "Spezielle Menüänderungen möglich",
            "Premium-Getränkepakete verfügbar"
          ]
        },
        additionalInfo: "Maßgeschneiderte Erlebnisse für besondere Anlässe"
      },
      details: {
        startTime: "10:00 - 15:00",
        totalCapacity: "12 Personen",
        totalBreaks: "3 Pausen",
        totalCabins: "1 Kabinen",
        catering: "Inklusive",
        alcoholDrink: "Möglich",
        special: "BBQ Party",
        length: "12 Meter",
        beam: "4 Meter",
        draft: "1,8 Meter",
        enginePower: "2 x 350 PS",
        fuelType: "Diesel",
        maxSpeed: "16 Knoten",
        cruisingSpeed: "16 Knoten",
        fuelConsumption: "50L/h",
        guestCapacity: {
          day: "12 Personen",
          overnight: "4 Personen"
        },
        cabins: {
          total: "2 Kabinen",
          master: "1 Masterkabine",
          double: "1 Doppelkabine",
          twin: "0 Zweibettkabinen"
        },
        bathrooms: "2 Badezimmer",
        navigation: [
          "GPS",
          "Radar",
          "UKW-Funk",
          "Autopilot",
          "Tiefenmesser"
        ],
        entertainment: [
          "TV",
          "Soundsystem",
          "WLAN",
          "Bluetooth-Verbindung"
        ],
        comfort: [
          "Klimaanlage",
          "Heizung",
          "Generator",
          "Warmwasser"
        ],
        waterToys: [
          "Schnorchelausrüstung",
          "Angelausrüstung",
          "Wasserski"
        ],
        includedServices: [
          "Professioneller Kapitän",
          "Crew",
          "Treibstoff",
          "Wasser",
          "Alkoholfreie Getränke",
          "Snacks",
          "Handtücher",
          "Versicherung"
        ],
        optionalServices: [
          
          {
            name: "Hoteltransfer",
            price: "?€ pro Strecke"
          },
          
        ],
        cancellation: {
          fullRefund: "7 Tage vorher",
          partialRefund: "3-7 Tage (50%)",
          noRefund: "weniger als 3 Tage"
        },
        availability: {
          checkIn: "10:00",
          checkOut: "15:00",
          minDuration: "1 Tag",
          seasonality: {
            highSeason: "Juni-September",
            lowSeason: "Oktober-Mai"
          }
        }
      },
      features: {
        yachtName: "Side VIP",
        yachtType: "Motoryacht",
        brand: "Individualbau",
        capacity: "12 Personen",
        crew: "2 Personen",
        cabin: "1",
        showerWC: "1",
        length: "12 Meter",
        width: "4 Meter",
        speed: "16 Knoten",
        manufacturing: "2008",
        refitDate: "2023",
        location: "Side Marina",
        distance: "15 km"
      },
      equipment: {
        comfort: [
          "WLAN",
          "Fernglas",
          "Außenlautsprecher",
          "GPS",
          "Kühlschrank",
          "Surfbrett",
          "Innenlautsprecher",
          "Handtuch",
          "Rettungsweste"
        ],
        activities: [
          "Badeleiter",
          "Grill",
          "Modernes Geschirr",
          "Bluetooth-Verbindung",
          "Angel-Ausrüstung",
          "Schnorchel und Flossen",
          "Sonnenliegen"
        ]
      },
      services: {
        included: {
          foodAndBeverage: {
            title: "Speisen und Getränke",
            description: "Kostenloses Menü und alkoholfreie Getränke inklusive."
          },
          
          fuel: {
            title: "Treibstoff",
            description: "Alle Treibstoffkosten im Charterpreis enthalten."
          },
          waiterAndCrew: {
            title: "Kellner und Crew",
            description: "Professioneller Crew-Service inklusive. Bitte informieren Sie uns im Voraus über besondere Bedingungen (z. B. Glutenallergie usw.). Keine zusätzlichen Kosten."
          },
          fixedMenu: {
            title: "Festes Menü",
            items: [
              "Frischer Fisch",
              "Gegrilltes Hähnchen",
              "Lokale Pasta",
              "Mediterraner Salat",
              "Saisonale Früchte",
              "Alkoholfreie Getränke",
              "Gegrilltes Gemüse"
              
            ]
          }
        },
        extras: {
          birthdayCake: {
            title: "Geburtstagstorte",
            description: "Individuelle Geburtstagstorten auf Anfrage verfügbar."
          },
          bringingAlcohol: {
            title: "Alkohol mitbringen",
            description: "35€ Servicegebühr für mitgebrachten Alkohol."
          },
          purchasingAlcohol: {
            title: "Alkohol kaufen",
            description: "An Bord zum Kauf verfügbar."
          },
          modifyingMenu: {
            title: "Menüänderungen",
            description: "Individuelle Menüoptionen gegen Aufpreis verfügbar."
          },
          
          waterActivities: {
            title: "Wasseraktivitäten",
            description: "Zusätzliche Wassersportarten gegen Gebühr. Jet-Ski, Parasailing sind verfügbar."
          },
          photographyServices: {
            title: "Fotografie und Drohnenaufnahmen",
            description: "Professionelle Foto- und Drohnendienste verfügbar."
          },
          transfer: {
            title: "Transfer",
            description: "Individuelle Transferservices je nach Gruppengröße."
          },
          decoration: {
            title: "Dekoration",
            description: "Individuelle Dekorationen für besondere Anlässe verfügbar."
          },
        }
      },
      images: [
        '/images/20240523_132216.jpg',
        '/images/20240528_122608.jpg',
        '/images/20240609_194627.jpg',
        '/images/DJI_0720+ kopya.jpg',
        '/images/IMG_20220603_140435_581.jpg',
        '/images/IMG_20220711_225349_830.jpg',
        '/images/IMG-20230525-WA0014.jpg',
        '/images/IMG-20230501-WA0005.jpg'
      ],
      image: "/images/20240520_111108.jpg",
      year: 2008,
      length: "12,5m"
    }
  },
  ru: {
    2: {
      name: "Side VIP",
      price: "Начиная с 100 €",
      priceUnit: "в день",
      location: "Порт Сиде, Турция",
      builder: "Собственная сборка",
      description: {
        main: "Насладитесь роскошным яхтингом в Сиде на нашем VIP судне",
        highlights: [
          "Премиум-сервис в прекрасных водах Сиде",
          "Профессиональный экипаж к вашим услугам",
          "Ежедневные туры с 09:30 до 15:00"
        ],
        location: {
          departure: "Марина Сиде-Манавгат",
          route: "Живописные бухты Сиде"
        },
        includedMenu: {
          mainDishes: [
            "Свежая рыба",
            "Курица-гриль",
            "Паста",
            "Местные деликатесы"
          ],
          sides: [
            "Средиземноморский салат",
            "Турецкие закуски"
          ],
          beverages: [
            "Безалкогольные напитки",
            "Вода",
            "Чай",
            "Кофе"
          ]
        },
        extraServices: {
          note: "Индивидуальный подход с дополнительными услугами по запросу",
          options: [
            "Доступны расширенные маршруты",
            "Возможны изменения в меню",
            "Доступны премиум-пакеты напитков"
          ]
        },
        additionalInfo: "Индивидуальные впечатления для особых случаев и мероприятий"
      },
      details: {
        startTime: "10:00 - 15:00",
        totalCapacity: "12 человек",
        totalBreaks: "3 остановки",
        totalCabins: "1 каюты",
        catering: "Включено",
        alcoholDrink: "Возможно",
        special: "BBQ вечеринка",
        length: "12 метра",
        beam: "4 метра",
        draft: "1,8 метра",
        enginePower: "2 x 350 л.с.",
        fuelType: "Дизель",
        maxSpeed: "20 узлов",
        cruisingSpeed: "16 узлов",
        fuelConsumption: "50 л/ч",
        guestCapacity: {
          day: "12 человек",
          overnight: "4 человека"
        },
        cabins: {
          total: "2 каюты",
          master: "1 главная каюта",
          double: "1 двухместная каюта",
          twin: "0 кают с раздельными кроватями"
        },
        bathrooms: "2 ванные комнаты",
        navigation: [
          "GPS",
          "Радар",
          "Радио УКВ",
          "Автопилот",
          "Эхолот"
        ],
        entertainment: [
          "Телевизор",
          "Аудиосистема",
          "Wi-Fi",
          "Bluetooth подключение"
        ],
        comfort: [
          "Кондиционер",
          "Отопление",
          "Генератор",
          "Горячая вода"
        ],
        waterToys: [
          "Снаряжение для снорклинга",
          "Рыболовные снасти",
          "Водные лыжи"
        ],
        includedServices: [
          "Профессиональный капитан",
          "Экипаж",
          "Топливо",
          "Вода",
          "Безалкогольные напитки",
          "Закуски",
          "Полотенца",
          "Страховка"
        ],
        optionalServices: [
          
          {
            name: "трансфер из отеля",
            price: "?€ за поездку"
          },
          
        ],
        cancellation: {
          fullRefund: "за 7 дней",
          partialRefund: "3-7 дней (50%)",
          noRefund: "менее 3 дней"
        },
        availability: {
          checkIn: "10:00",
          checkOut: "15:00",
          minDuration: "1 день",
          seasonality: {
            highSeason: "Июнь-Сентябрь",
            lowSeason: "Октябрь-Май"
          }
        }
      },
      features: {
        yachtName: "Side VIP",
        yachtType: "Моторная яхта",
        brand: "Собственная сборка",
        capacity: "12 человек",
        crew: "2 человека",
        cabin: "1",
        showerWC: "1",
        length: "12 метра",
        width: "4 метра",
        speed: "16 узлов",
        manufacturing: "2008",
        refitDate: "2023",
        location: "Марина Сиде",
        distance: "15 км"
      },
      equipment: {
        comfort: [
          "Wi-Fi",
          "Бинокль",
          "Наружные динамики",
          "GPS",
          "Холодильник",
          "доска для серфинга",
          "Внутренние динамики",
          "Полотенце",
          "спасательный жилет"
        ],
        activities: [
          "Лестница для купания",
          "Гриль",
          "Современный набор посуды",
          "Bluetooth подключение",
          "Любительское рыболовное снаряжение",
          "Сноркель и ласты",
          "Солнечные подушки"
        ]
      },
      services: {
        included: {
          foodAndBeverage: {
            title: "Еда и напитки",
            description: "Бесплатное меню и безалкогольные напитки включены."
          },
          
          fuel: {
            title: "Топливо",
            description: "Все расходы на топливо включены в стоимость аренды."
          },
          waiterAndCrew: {
            title: "Официант и экипаж",
            description: "Услуги профессионального экипажа включены.Пожалуйста, сообщите нам заранее о любых особых условиях (например, аллергия на глютен и т. д.). Дополнительная плата не взимается."
          },
          fixedMenu: {
            title: "Фиксированное меню",
            items: [
              "Свежая рыба",
              "Курица-гриль",
              "Местная паста",
              "Средиземноморский салат",
              "Сезонные фрукты",
              "Безалкогольные напитки",
              "Овощи гриль"
              
            ]
          }
        },
        extras: {
          birthdayCake: {
            title: "Торт на день рождения",
            description: "Индивидуальные торты на день рождения доступны по запросу."
          },
          bringingAlcohol: {
            title: "Принесение алкоголя",
            description: "Сервисный сбор 35€ за свой алкоголь."
          },
          purchasingAlcohol: {
            title: "Покупка алкоголя",
            description: "Доступно для покупки на борту."
          },
          modifyingMenu: {
            title: "Изменение меню",
            description: "Индивидуальные варианты меню за дополнительную плату."
          },
          
          waterActivities: {
            title: "Водные активности",
            description: "Дополнительные водные виды спорта за плату. Доступны гидроцикл и парасейлинг."
          },
          photographyServices: {
            title: "Фотография и съемка с дрона",
            description: "Доступны профессиональные фото- и дрон-услуги."
          },
          transfer: {
            title: "Трансфер",
            description: "Индивидуальные трансферы в зависимости от размера группы."
          },
          decoration: {
            title: "Оформление",
            description: "Специальное оформление доступно для особых случаев."
          },
        }
      },
      images: [
        '/images/20240523_132216.jpg',
        '/images/20240528_122608.jpg',
        '/images/20240609_194627.jpg',
        '/images/DJI_0720+ kopya.jpg',
        '/images/IMG_20220603_140435_581.jpg',
        '/images/IMG_20220711_225349_830.jpg',
        '/images/IMG-20230525-WA0014.jpg',
        '/images/IMG-20230501-WA0005.jpg'
      ],
      image: "/images/20240520_111108.jpg",
      year: "2008",
      length: "12,5 м"
    }
  }
}; 